import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsConstants } from './models/globals-constants.modelo';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'UMO-FrontEnd';
  // Name de los botones de accion
  globalConstants: GlobalsConstants = new GlobalsConstants();

  // interval
  interval;

  // Subscription
  subscription$: Subscription;
  
  constructor(){}

  ngOnInit() {
  }

}
